import Link from "next/link";
import { Heart } from "lucide-react";

const FOOTER_LINKS = [
  { href: "/impressum", label: "Impressum" },
  { href: "/datenschutz", label: "Datenschutz" },
] as const;

const FOOTER_TEXT_CLASS = "footer-text text-sm lg:text-base text-[var(--dark-blue)] font-bold font-[Poppins] text-shadow-yellow tracking-[0.5px]";

const Footer = () => {
    return (
        <footer className="w-full px-5 pb-5 bg-transparent">
            <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-4 lg:gap-0">
                <p className={`flex items-center gap-1 m-0 ${FOOTER_TEXT_CLASS}`}>
                    <span>©</span> 2025 Timo Möwes. Made with{" "}
                    <Heart size={16} className="footer-icon inline-block text-[var(--red)] fill-[var(--red)]" strokeWidth={0} />{" "}
                    in Berlin
                </p>
                <nav className="flex items-center gap-3 lg:gap-5">
                    {FOOTER_LINKS.map(({ href, label }, index) => (
                        <div key={href} className="flex items-center gap-3 lg:gap-5">
                            {index > 0 && <span className={FOOTER_TEXT_CLASS}>•</span>}
                            <Link 
                                href={href}
                                className={`no-underline transition-all duration-200 hover:-translate-y-0.5 hover:scale-105 ${FOOTER_TEXT_CLASS}`}
                            >
                                {label}
                            </Link>
                        </div>
                    ))}
                </nav>
            </div>
        </footer>
    );
};
 
export default Footer;